import React from "react";
import PropTypes from "prop-types";

const badgeColors = [
  {
    bg: "bg-blue-100",
    text: "text-blue-800",
    border: "border-blue-300",
  },
  {
    bg: "bg-yellow-100",
    text: "text-yellow-800",
    border: "border-yellow-300",
  },
  {
    bg: "bg-red-100",
    text: "text-purple-800",
    border: "border-purple-300",
  },
  {
    bg: "bg-green-100",
    text: "text-green-800",
    border: "border-green-300",
  },
];

const BranchBadges = ({ branches = [] }) => {
  if (!branches.length) {
    return (
      <div className="flex items-center gap-2 text-gray-500">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
        <span>No Active Branches</span>
      </div>
    );
  }

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {branches.map((branch, index) => {
        const color = badgeColors[index % badgeColors.length];

        return (
          <span
            key={branch.branchId || index}
            className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border transition-all duration-200 hover:-translate-y-[1px] hover:shadow ${color.bg} ${color.text} ${color.border}`}
          >
            {branch.branchName}
          </span>
        );
      })}
    </div>
  );
};

BranchBadges.propTypes = {
  branches: PropTypes.arrayOf(
    PropTypes.shape({
      branchId: PropTypes.number,
      branchName: PropTypes.string,
    })
  ),
};

export default BranchBadges;
